import React from 'react'
import { Horizontal, Vertical, Texto, addCommasToNumber } from '@gravitate-js/excalibrr'
import { Avatar, Progress } from 'antd'

export const PaceMetric = ({ value, loaded, allocation, type = 'regular', letter, isContract }) => {
  if (!value && value !== 0)
    return (
      <Texto style={{ fontStyle: 'italic' }} appearance='medium' weight={500}>
        {loaded}
      </Texto>
    )
  const getStatus = () => {
    if (value < 0.85 && isContract) {
      return 'exception'
    } else if (value > 1 && !isContract) {
      return 'exception'
    }
    return 'success'
  }
  const getAppearance = () => {
    if (value < 0.85 && isContract) {
      return 'error'
    } else if (value > 1 && !isContract) {
      return 'error'
    }

    return 'success'
  }
  if (type === 'regular') {
    return (
      <Vertical flex={1}>
        <div className='flex  '>
          <Progress
            size='small'
            showInfo={false}
            className='driver-scorecard'
            strokeWidth={10}
            strokeLinecap='square'
            percent={value * 100}
            status={getStatus()}
          />
          <Texto
            appearance={getAppearance()}
            category='h6'
            style={{ lineHeight: 1, alignSelf: 'center' }}
            className='pl-3 pt-1'
            weight='bold'
          >
            {addCommasToNumber(value * 100, 0)}%
          </Texto>
        </div>
        <Horizontal flex={1}>
          <Texto appearance='medium' category='label' weight='bold'>
            {addCommasToNumber(loaded, 0)} / {addCommasToNumber(allocation, 0)}
          </Texto>
        </Horizontal>
      </Vertical>
    )
  }
  return (
    <Vertical flex={1}>
      <div className='flex items-center' style={{ gap: 4 }}>
        <Avatar
          className='mr-2'
          size={14}
          style={{ background: 'var(--theme-color-1)', fontSize: '0.8em', minWidth: 14, fontWeight: 'bold' }}
        >
          {letter}
        </Avatar>
        <Progress
          size='small'
          showInfo={false}
          className='driver-scorecard'
          strokeWidth={10}
          strokeLinecap='square'
          percent={value * 100}
          status={getStatus()}
        />
        <Texto style={{ whiteSpace: 'pre' }} appearance='medium' category='label' weight='bold'>
          {addCommasToNumber(loaded, 0)} / {addCommasToNumber(allocation, 0)}
        </Texto>
        <Texto appearance={getAppearance()} category='h6' style={{ whiteSpace: 'nowrap' }} weight='bold'>
          ({addCommasToNumber(value * 100, 0)}%)
        </Texto>
      </div>
    </Vertical>
  )
}
